import type { Fragment } from '@atlaskit/editor-prosemirror/model';
import type { EditorView } from '@atlaskit/editor-prosemirror/view';

import { eventHub } from '../../../../pm-plugins/ai-event-hub/event-hub';
import { findEditorIdFromView } from '../../../../pm-plugins/ai-event-hub/utils/isolated-utils';

export function replaceConfluenceTitle({
	editorView,
	pmFragment,
	isFinal,
	fireUnifiedAnalyticsEvent,
}: {
	editorView: EditorView;
	fireUnifiedAnalyticsEvent?: (eventType: 'actioned' | 'discarded') => void;
	isFinal?: boolean;
	pmFragment: Fragment;
}): void {
	const fragmentToInsert = pmFragment;
	let textContent = '';
	fragmentToInsert.forEach((node) => {
		textContent += node.textContent;
	});
	const confluenceTitle = document.querySelector(
		'textarea[data-ai-suggest-title-target="true"]',
	) as HTMLTextAreaElement;
	if (confluenceTitle) {
		const sourceEditorId = findEditorIdFromView(editorView);
		if (sourceEditorId) {
			eventHub.publishFromEditor({
				event: 'replace title in confluence',
				data: {
					analyticSourceId: 'confluenceTitleToolbar',
					sourceEditorId,
					title: textContent,
					...(isFinal !== undefined && { isFinal }),
					...(fireUnifiedAnalyticsEvent && { fireUnifiedAnalyticsEvent }),
				},
			});
			confluenceTitle.scrollIntoView({ block: 'nearest' });
		}
	}
}
